import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_CZ: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Fitness',
  components_header_media_1: 'Pro muže',
  components_header_media_2: 'Pro ženy',
  components_header_media_multi_content_2: 'Jóga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Trénujte chytřeji, ciťte se lépe.',
  hero_button_text: 'Začněte hned teď',
  components_ressources_subheader_text: 'Průvodci a tipy',
  components_ressources_span_text: 'Kombinuje přírodní zaměření jógy, kontrolovanou preciznost pilates a dynamickou výzvu silového tréninku pro podporu všestranného a zdravého životního stylu.',
  components_ressources_card_1_title: 'Tipy na jógu',
  components_ressources_card_1_text: 'Stručný návod pro lepší rovnováhu, dýchání a plynutí.',
  components_ressources_card_2_title: 'Tipy na pilates',
  components_ressources_card_2_text: 'Jednoduché tipy pro posílení svalů středu těla a zlepšení kontroly.',
  components_notes_and_google_title_1: 'Budujte sílu',
  components_notes_and_google_title_2: 'Jóga Klid',
  components_notes_and_google_title_3: 'Pilates střed těla',
  media_content_section_multi_1_subheader_text: 'Tréninková videa',
  media_content_section_multi_2_subheader_text: 'Jóga videa',
  media_content_section_multi_3_subheader_text: 'Videa o pilates',
  text_media_1: 'Muži',
  text_media_2: 'Ženy',
  page_media_content_menu_biceps: 'Biceps',
  page_media_content_menu_triceps: 'Triceps',
  page_media_content_menu_back: 'Zadní',
  page_media_content_menu_chest: 'Truhla',
  page_media_content_menu_legs: 'Nohy',
  page_media_content_menu_shoulders: 'Ramena',
  page_media_content_menu_abdominals: 'Břišní svaly',
  components_text1_subheader_text: 'Zdravá strava pro váš aktivní život',
  components_text1_span_text: 'Zdravé recepty, které podpoří váš trénink a zlepší vaši pohodu.',
  components_footer_text: 'Posilte své tělo, vyvažte svou mysl a pohybujte se smysluplně – vaše místo pro posilovnu, jógu a pilates.',
};